import { render, staticRenderFns } from "./MetaNav.vue?vue&type=template&id=4c253635&"
import script from "./MetaNav.vue?vue&type=script&lang=js&"
export * from "./MetaNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports